import React from "react";

import "./online.scss";

import {Label} from "semantic-ui-react";


interface OnlineProps {
    online: boolean;
}

export class Online extends React.Component<OnlineProps, any> {

    constructor(props: OnlineProps) {
        super(props);
        this.state = {};
    }

    componentDidMount() {}

    componentWillUnmount() {}

    render() {
        const {online} = this.props;

        return (
            <Label
                color={online ? "blue" : "grey"}
                className="geo-station-online" size="tiny"
                title={online ? "kontinuierliche Datenübertragung" : "manuelle Datenübertragung"}
            >
                {online ? "mit DFÜ" : "ohne DFÜ"}
            </Label>
        );
    }

}
